import { createSlice } from "@reduxjs/toolkit";
import jwt_decode from "jwt-decode";

const initialState = {
  token: localStorage.getItem("token"),
  bearerToken: null,
  isTokenValid: false,
  authenticated: false,
  user: null,         
  profile: null,     
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setToken: (state, action) => {
      try {
        const decodedToken = jwt_decode(action.payload);
        const expiration = decodedToken.exp * 1000;
        const isTokenValid = expiration > Date.now();

        if (isTokenValid) {
          localStorage.setItem("token", action.payload);
          state.user = decodedToken;
          state.token = action.payload;
          state.bearerToken = `Bearer ${action.payload}`;
          state.isTokenValid = true;
          state.authenticated = true;
        } else {
          localStorage.removeItem("token");
          state.token = null;
          state.bearerToken = null;
          state.isTokenValid = false;
          state.authenticated = false;
          state.user = null;
          state.profile = null;
        }
      } catch (err) {
        console.error("JWT decode failed", err);
        localStorage.removeItem("token");
        state.token = null;
        state.bearerToken = null;
        state.isTokenValid = false;
        state.authenticated = false;
        state.user = null;
        state.profile = null;
      }
    },

    checkToken: (state) => {
      if (state.token && state.token !== "undefined") {
        try {
          const decodedToken = jwt_decode(state.token);
          const expiration = decodedToken.exp * 1000;
          const isTokenValid = expiration > Date.now();

          if (isTokenValid) {
            state.user = decodedToken;
            state.bearerToken = `Bearer ${state.token}`;
            state.isTokenValid = true;
            state.authenticated = true;
          } else {
            localStorage.removeItem("token");
            state.token = null;
            state.bearerToken = null;
            state.isTokenValid = false;
            state.authenticated = false;
            state.user = null;
            state.profile = null;
          }
        } catch (err) {
          console.error("JWT decode failed", err);
          localStorage.removeItem("token");
          state.token = null;
          state.bearerToken = null;
          state.isTokenValid = false;
          state.authenticated = false;
          state.user = null;
          state.profile = null;
        }
      }
    },

    setProfile: (state, action) => {
      state.profile = action.payload;
    },

    setProfileImage: (state, action) => {
      if (state.profile) {
        state.profile.profileImage = action.payload;
      }
    },

    clearUser: (state) => {
      localStorage.removeItem("token");
      return { ...initialState, token: null };
    },
  },
});

export const {
  setToken,
  checkToken,
  setProfile,
  setProfileImage,
  clearUser,
} = userSlice.actions;

export const selectUser = (state) => state.user.user;
export const selectProfile = (state) => state.user.profile;

export default userSlice.reducer;
